import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as models from '../../../utils/models';

class VTCoverForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		scopeOfWork: Joi.string().min(5).required().label('Scope Of Work'),
		vtProcedure: Joi.string().min(5).required().label('VT Procedure'),
		codeOfPractice: Joi.string()
			.min(3)
			.required()
			.label('Rope Access Code of Practice'),
		ndtQualification: Joi.string()
			.min(3)
			.required()
			.label('Qualification of NDT Personnel'),
		destructiveTesting: Joi.string()
			.min(3)
			.required()
			.label('Non Destructive Testing'),
		pipingInspectionCode: Joi.string()
			.min(3)
			.required()
			.label('Process Piping Inspection Code'),
		pipingDesign: Joi.string().min(3).required().label('Process Piping Design'),
		pipingSystemComponent: Joi.string()
			.min(3)
			.required()
			.label('Process Piping Design'),
		damageMechanisms: Joi.string()
			.min(3)
			.required()
			.label(
				'Damage Mechanisms affecting Fixed Equipment in the Refining Industry'
			),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scopeOfWork',
							label: 'Scope of work',
							placeholder: 'Enter Scope of Work',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'vtProcedure',
							label: 'VT Procedure',
							placeholder: 'Enter VT Procedure',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'codeOfPractice',
							label: 'Rope Access Code of Practice',
							placeholder: 'Enter Rope Access Code of Practice',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'destructiveTesting',
							label: 'Non Destructive Testing',
							placeholder: 'e.g. ASNT SNT-TC-1A',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndtQualification',
							label: 'Qualification of NDT Personnel',
							placeholder: 'e.g. ASNT SNT-TC-1A',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'damageMechanisms',
							label: 'Damage Mechanisms affecting Fixed Equipment',
							placeholder: 'e.g. API 571',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'pipingInspectionCode',
							label: 'Process Piping Inspection Code',
							placeholder: 'Enter Piping Inspection Code',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'pipingDesign',
							label: 'Process Piping Design',
							placeholder: 'Enter Process Piping Design',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'pipingSystemComponent',
							label: 'Inspection of Piping System Component',
							placeholder: 'Enter Inspection of Piping System Component Value',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData: models.VTCoverData = {
	scopeOfWork: '',
	vtProcedure: '',
	codeOfPractice: '',
	pipingInspectionCode: '',
	pipingDesign: '',
	pipingSystemComponent: '',
	ndtQualification: '',
	destructiveTesting: '',
	damageMechanisms: '',
};

export default VTCoverForm;
